import { render, staticRenderFns } from "./manualTrx.vue?vue&type=template&id=ef76730e&scoped=true&"
import script from "./manualTrx.vue?vue&type=script&lang=js&"
export * from "./manualTrx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef76730e",
  null
  
)

export default component.exports